export default "__VITE_ASSET__C4aY2Gtu__"